<template>
    <div>
        <v-card class="mt-2">
            <v-card-title class="q_leads_1 align-start" style="font-size: 1rem" :id=" entity + '_datatable'">
                <v-col cols="12" sm="6">
                    <div class="d-flex align-center">
                        <p class="q-display-3 mb-0" id="datatable">
                            {{ title }}
                        </p>
                        <v-btn icon @click="refresh">
                            <v-icon>fas fa-redo-alt</v-icon>
                        </v-btn>
                    </div>
                    <p class="pt-2 mb-0">
                        <v-btn class="pa-2" text small color="q_leads_4" @click="toggleFilters">
                            <v-icon small left>fas fa-filter</v-icon> Filter Applications
                        </v-btn>
                    </p>
                </v-col>
                <v-col cols="12" sm="6">
                    <!-- Searchbar with issues -->
                    <!-- <v-text-field dense dark v-model="search" append-icon="icon-q-search" label="Search" single-line hide-details @keyup="maybeSearch" @click:append="refreshData" /> -->
                    <q-time-period-select :dark="true" v-model="time_filters" label="Time Period" :with-all="true" :allow-current="true" stateKey="stat"></q-time-period-select>
                </v-col>
            </v-card-title>
            <v-card-text v-show="$refs.filters && $refs.filters.show">
                <v-row class="d-flex justify-start">
                    <q-filters dark ref="filters" :hide-button="true" v-model="filters" :available-filters="available_filters" :keys="filter_keys">
                        <v-switch hide-details inset v-model="include_downlines" label="Include Downline"></v-switch>
                    </q-filters>
                </v-row>
            </v-card-text>
            <v-row class="mx-4 my-2">
                <v-col cols="12" class="d-flex justify-end" v-if="total_items > 0">
                    <v-btn text small color="q_leads_4" @click="exportResults">
                        <v-icon small left>fas fa-file-export</v-icon> Export Results
                    </v-btn>
                </v-col>
            </v-row>
            <v-form lazy-validation v-model="valid" ref="form" :disabled="saving">
                <v-data-table v-on:current-items="updateCurrentItems" :mobile-breakpoint="2" :items-per-page.sync="rows" :search="search" v-model="selected" :headers="the_headers" :items="all_data" item-key="$id" class="elevation-0 pointer" :footer-props="{ itemsPerPageOptions: [10, 25, 50, 100] }" :loading="loading" :options.sync="options" :server-items-length="total_items">
                    <template v-slot:item.SubmittedDate="{ item }">
                        <span class="nowrap">{{ formatDate(item.SubmittedDate) }}</span>
                    </template>
                    <template #item.IssuedDate="{ item }">
                        <div style="min-width: 125px;">
                            <QDatePicker
                                v-model="all_data[itemIndexOf(item.ID)].IssuedDate" 
                            />
                        </div>
                    </template>
                    <template v-slot:item.AgentName="{ item }">
                        <a @click.stop.prevent="viewAgent(item.AgentCode)">{{item.AgentName}}</a>
                    </template>
                    <template v-slot:item.FirstName="{ item }">
                        <span class="nowrap"> {{ item.FirstName }} {{ item.LastName }} </span>
                    </template>
                    <template v-slot:item.APV="{ item }">
                        <v-text-field dense outlined hide-details label="APV" v-model="all_data[itemIndexOf(item.ID)].APV" :rules="[rules.number]" prepend-inner-icon="fas fa-dollar-sign"></v-text-field>
                    </template>
                    <template v-slot:item.FaceAmount="{ item }">
                        <v-text-field dense outlined hide-details label="FaceAmount" v-model="all_data[itemIndexOf(item.ID)].FaceAmount" :rules="[rules.number]" prepend-inner-icon="fas fa-dollar-sign"></v-text-field>
                    </template>
                    <template v-slot:item.PolicyNumber="{ item }">
                        <v-text-field dense outlined hide-details label="PolicyNumber" v-model="all_data[itemIndexOf(item.ID)].PolicyNumber"></v-text-field>
                    </template>
                    <template v-slot:item.ID="{ item }">
                        <v-btn color="primary" icon @click="editApplication(item.ID)"><v-icon>fas fa-edit</v-icon></v-btn>
                    </template>
                    <template v-slot:item.Status="{ item }">
                        <v-select :items="status_items" dense outlined hide-details label="Status" v-model="all_data[itemIndexOf(item.ID)].Status"></v-select>
                    </template>
                    <template v-slot:item.PaidInd="{ item }">
                        <v-checkbox dense outlined v-model="all_data[itemIndexOf(item.ID)].PaidInd"></v-checkbox>
                    </template>
                    <template v-slot:body.append>
                        <tr v-if="all_data.length > 0">
                            <td colspan="8"></td>
                            <td class="title">
                                <v-btn @click="saveBulkUpdate" block color="primary">
                                    Save Changes <v-progress-circular size="20" v-if="saving" indeterminate></v-progress-circular>
                                </v-btn>
                        </td>
                        </tr>
                    </template>
                    <!--
                    <template v-slot:body.append>
                        <tr>
                            <th class="title">Totals</th>
                            <th colspan="5"></th>
                            <th class="title">{{ sumField("APV") }}</th>
                        </tr>
                    </template>
                    -->
                </v-data-table>
            </v-form>
        </v-card>
        <v-dialog width="70%" v-model="showAppForm">
            <v-card class="pa-10">
                <q-new-application :application-id="currentApplicationID" ref="appform" v-on:close="closeApp"></q-new-application>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import QDataTableMixin from "./QDataTableMixin";
import Application from "@/store/Models/Application";
import QuilityAPI from "@/store/API/QuilityAPI.js";
import { debounce } from "vue-debounce";
import StateOptions from "@/store/StateOptions";
import QDataTableHeader from "./base/QDataTableHeader.vue";
import QTimePeriodSelect from '@/components/utils/QBusinessTimePeriodSelect.vue';
import QScoreCardPieChart from '@/components/stats/scorecards/QScoreCardPieChart.vue'
import moment from 'moment';
import rules from '@/components/utils/ValidationRules'
import QNewApplication from '@/components/applications/QNewApplication.vue'
import QDatePicker from "../utils/QDatePicker.vue";

export default {
    name: "QApplicationsBulkEditDataTable",
    mixins: [QDataTableMixin],
    props: ["agent"],
    data: function() {
        // data internal to component (not available outside)
        return {
            entity: "application",
            view_application_details: false,
            //use this to "preset" a filter
            filters: {},
            time_filters : {},
            firstPull: true, // this keeps the auto scrolling on data reloads from happening on the first load.
            applications: [],
            current_application: null,
            options: { sortBy: ["SubmittedDate"], sortDesc: ["true"] },
            saving: false,
            valid : false,
            is_exporting: false,
            states: StateOptions, //for the state drop down list
            warning: null,
            error: null,
            orig_application_status: null,
            include_downlines : true,
            datePeriod: { label: 'Current Month', 'period': 'month' },
            rules: rules, //validation rules imported.
            showAppForm : false,
            currentApplicationID : null,
            saving : false
        };
    },
    mounted: function() {

    },
    computed: {
        filter_keys: function() {
            return Application.state().filter_keys;
        },
        all_data: function() {
            return this.applications;
        },
        the_headers() {
            const r = [
                {
                    text: "Submitted",
                    value: "SubmittedDate",
                    align: "start",
                    sortable: true,
                    filterable: true,
                },
                {
                    text: "Agent",
                    value: "AgentName",
                    align: "start",
                    sortable: true,
                    filterable: true,
                    class: "header-class",
                },
                {
                    text: "Policy #",
                    value: "PolicyNumber",
                    align: "start",
                    sortable: true,
                    filterable: true,
                    class: "header-class",
                },
                {
                    text: "Name",
                    value: "FirstName",
                    align: "start",
                    sortable: true,
                    filterable: true,
                    class: "header-class",
                },
                this.hasRole(['Staff', 'SuperAdmin']) ? {
                    text: "Issued Date",
                    value: "IssuedDate",
                    sortable: true,
                    filterable: true,
                } : null,,
                {
                    text: "APV",
                    value: "APV",
                    sortable: true,
                    filterable: true,
                },
                {
                    text: "Face Amount",
                    value: "FaceAmount",
                    sortable: true,
                    filterable: true,
                },
                {
                    text: "Paid",
                    value: "PaidInd",
                },
                {
                    text: "Status",
                    value: "Status",
                    sortable: true,
                    filterable: true,
                },{
                    text: "Edit",
                    value: "ID",
                    sortable: true,
                    filterable: true,
                },
            ].filter(Boolean)
            return r;
        },
        'status_items' : function(){
            return [
                'Active',
                'Agency-Approved',
                'Approved',
                'Deleted',
                'Duplicate',
                'Incomplete',
                'New Application',
                'Submitted'
            ]
        }
    },
    methods: {
        loadData: debounce(function(opt) {
            const g = this;
            let getAgentCode = ''
            var f = {
                ...g.filters,
                startDate : g.time_filters.startDate,
                endDate : g.time_filters.endDate,
                include_downlines : g.include_downlines
            }
			g.agentCode ? getAgentCode = g.agentCode : getAgentCode = g.user.Agent.AgentCode
            QuilityAPI.getApplications(getAgentCode, f, opt)
                .then(function(results) {
                    if (typeof results.data != "undefined") {
                        g.applications = results.data;
                    } else {
                        g.showError("Whoops! " + results.message);
                    }
                    Application.commit((state) => {
                        state.loading = false;
                    });
                    if (results.meta){

                    }
                })
                .catch(function(err) {
                    console.log(err);
                    if (err.status == 431) {
                        g.showError(err + " You probably need to clear all your cookie and session variables and login again.");
                        return;
                    }
                    //g.showError(err.status)
                });
            g.firstPull = false;
        }, 200),
        saveBulkUpdate : function(){
            var g = this
            var validated = this.$refs.form.validate();
            if (!validated){
                this.warning = 'Please fill out all required fields!';
                this.goToTop()
                return
            }
            g.saving = true;
            QuilityAPI.bulkUpdateApplications({'applications' : this.applications}).then(function(json){
                g.saving = false;
                if (json.Success === true){
                    g.showInfo("Success! Application changes have been saved!")
                }else{
                    g.showError("Uh oh! There was a problem saving the applications! " + json.msg)
                }
            }).catch(function(err){
                g.saving = false;
                g.showError(err)
            });
        },
        refresh: function() {
            const g = this;
            g.applications = [];
            Application.commit((state) => {
                state.total = null;
                state.availableFilters = null;
            });
            g.refreshData();
        },
        exportResults: function() {
            const g = this;
            var f = {
                ...g.filters,
                startDate : g.time_filters.startDate,
                endDate : g.time_filters.endDate,
                include_downlines : g.include_downlines
            }
            let opt = {
                ...g.options,
                search: g.search,
            };
            let endpoint = '/api/private/agent/' + g.user.Agent.AgentCode + '/applications';
            let params = {
                ...opt,
                ...f,
                itemsPerPage: "csv",
            };
            g.dispatchJob({
                method: "GET",
                path: endpoint,
                params: params,
                JobName: "Applications Export",
            });
        },
        status_itemsHasIndexOf: function(s) {
            for (var i = 0; i < this.status_items.length; i++) {
                if (this.status_items[i].Status == s) {
                    return true;
                }
            }
            return false;
        },
        getStatus: function(s) {
            for (var i = 0; i < this.status_items.length; i++) {
                if (this.status_items[i].Status == s) {
                    return this.status_items[i];
                }
            }
            return null;
        },
        updateFilters(filters) {
            Object.keys(this.filters).forEach((key) => {
                this.filters[key] = filters[key] || "-All-";
            });

            this.goToTop();
        },
        goToTop: function() {
            this.$vuetify.goTo("#" + this.entity + "_datatable", {
                duration: 500,
                easing: "easeOutCubic",
                offset: 300,
            });
        },
        formatDate(value) {
            return moment(value).format("YYYY-MM-DD")
        },
        formatCurrency (value) {
            return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value)
        },
        sumField(key) {
            let totals = this.applications.reduce((a, b) => a + Number((b[key] || 0)), 0)
            return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(totals)
        },
        viewAgent(agentCode){
            this.$router.push({ name: 'AgentDetail', params: { agentcode: agentCode} })
        },
        itemIndexOf(id){
            var index = null;
            this.all_data.forEach(function(v, ix){
                if (v.ID == id){
                    index = ix
                }
            });
            return index
        },
        editApplication(id){
            this.currentApplicationID = id
            this.showAppForm = true
        },
        closeApp : function(){
            this.currentApplicationID = null
            this.$refs.appform.reset()
            this.showAppForm = false;
        }
    },
    watch: {
        view_application_details: function() {
            this.current_application.Status = this.orig_application_status;
            this.logActivity("ViewApplication", { AgentCode: this.user.Agent.AgentCode });
        },
        time_filters : function(){
            this.$nextTick(this.refreshData);
        },
        'include_downlines' : function(){
            this.$nextTick(this.refreshData);
        },
        'options': function(){
        }
    },
    components: {
        QDataTableHeader,
        QTimePeriodSelect,
        QScoreCardPieChart,
        QNewApplication,
        QDatePicker
    },
};
</script>
<style scoped>
.nowrap {
    white-space: nowrap;
}
.table-cursor tbody tr:hover {
    cursor: pointer;
}
</style>